import gql from 'graphql-tag';

export const createNotifications = gql`
  mutation CreateNotifications($input: CreateNotificationsPayload!) {
    createNotifications(input: $input) {
      id
      type
      title
      description
      messageInSpanish
      messageInEnglish
      createdDate
      createdTime
      createdAt
      updatedAt
    }
  }
`; 